import { css } from "#styled-system/css";

export const SLIDER_STYLE = css.raw({
  columnGap: "16px",
  display: "grid",
  gridTemplateAreas: '"label value-text" "control control"',
  gridTemplateColumns: "repeat(2, 1fr)",
  rowGap: "4px",

  "&[data-disabled]": {
    _disabled: { cursor: "not-allowed", opacity: 0.5 },
  },

  '&:has([data-scope="slider"][data-part="control"]:only-child)': {
    rowGap: 0,
  },

  '& [data-scope="slider"][data-part="label"]': {
    fontFamily: '"Noto Sans JP", "Noto Color Emoji", serif',
    fontSize: "0.75rem",
    fontWeight: 500,
    gridArea: "label",
    justifySelf: "start",
    lineHeight: 4 / 3,
  },

  '& [data-scope="slider"][data-part="value-text"]': {
    color: "#737373",
    fontFamily: '"Noto Sans JP", "Noto Color Emoji", serif',
    fontSize: "0.875rem",
    fontWeight: 400,
    gridArea: "value-text",
    justifySelf: "end",
    lineHeight: 10 / 7,
  },

  '& [data-scope="slider"][data-part="control"]': {
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    gridArea: "control",
    height: "0.75rem",
    position: "relative",
  },
  '& [data-scope="slider"][data-part="track"]': {
    backgroundColor: "#F5F5F5",
    borderRadius: "65535px",
    flexGrow: 1,
    height: (1 / 3) * 100 + "%",
  },
  '& [data-scope="slider"][data-part="range"]': {
    backgroundColor: "#0D9488",
    borderRadius: "65535px",
    height: "100%",
  },
  '& [data-scope="slider"][data-part="thumb"]': {
    backgroundColor: "white",
    borderColor: "#A3A3A3",
    borderRadius: "50%",
    borderStyle: "solid",
    borderWidth: "1px",
    height: "12px",
    outline: "none",
    width: "12px",
  },
});
